import { findChildren, findParentNodeClosestToPos } from "@tiptap/core";
import { TIPTAP_COLLAPSIBLE_LIST_TYPE } from "./../../ricos-content";
import { getFragmentContentNodes } from "./../../ricos-plugins";
function updateCollapsibleListAttrs(commands, nodeId, attrs) {
  commands.updateNodeAttrsById(nodeId, attrs);
}
function updateCollapsibleListItemsAttrs(state, commands, nodeId, { initialExpandedItems }) {
  const collapsibleListNode = findNodeById(state, nodeId)[0].node;
  const nodes = getFragmentContentNodes(collapsibleListNode.content);
  nodes.forEach((node, index) => {
    const isExpanded = initialExpandedItems === "ALL" || index === 0 && initialExpandedItems === "FIRST";
    updateListItemAttributes(commands, node, {
      isExpanded
    });
  });
}
function updateListItemAttributes(commands, node, attrs) {
  commands.updateNodeAttrsById(node.attrs.id, attrs);
  const nodeContent = node.content;
  if (!!nodeContent && "content" in nodeContent && Array.isArray(nodeContent.content) && nodeContent.content[1]) {
    commands.updateNodeAttrsById(nodeContent.content[1].attrs.id, attrs);
  }
}
function isInCollapsibleList($pos, nodeId) {
  const collapsibleListNode = findParentNodeClosestToPos(
    $pos,
    (node) => node.type?.name === TIPTAP_COLLAPSIBLE_LIST_TYPE
  )?.node;
  const collapsibleListNodeContent = collapsibleListNode?.content;
  if (!collapsibleListNodeContent) {
    return false;
  }
  const fragmentNodes = getFragmentContentNodes(collapsibleListNodeContent);
  return fragmentNodes.some((node) => node.attrs.id === nodeId);
}
function findCollapsibleListById(state, nodeId) {
  let collapsibleList;
  state.doc.descendants((node) => {
    if (node.attrs.id === nodeId) {
      collapsibleList = node;
    }
  });
  return collapsibleList;
}
function getCollapsibleListItems(state, nodeId) {
  const collapsibleListNode = findCollapsibleListById(state, nodeId);
  if (collapsibleListNode?.type.name === TIPTAP_COLLAPSIBLE_LIST_TYPE) {
    return getFragmentContentNodes(collapsibleListNode.content);
  }
  return [];
}
function getCollapsibleListByItemId(state, nodeId) {
  const collapsibleLists = findNodesByType(state, TIPTAP_COLLAPSIBLE_LIST_TYPE);
  let collapsibleList;
  collapsibleLists.forEach((listNode) => {
    listNode.node.descendants((node) => {
      if (node.attrs.id === nodeId) {
        collapsibleList = listNode.node;
        return;
      }
    });
  });
  return collapsibleList;
}
const findNodesByType = (state, type) => {
  return findChildren(state.doc, (node) => node.type.name === type);
};
const findNodeById = (state, id) => {
  return findChildren(state.doc, (node) => node.attrs.id === id);
};
export {
  findNodeById,
  getCollapsibleListByItemId,
  getCollapsibleListItems,
  isInCollapsibleList,
  updateCollapsibleListAttrs,
  updateCollapsibleListItemsAttrs,
  updateListItemAttributes
};
//# sourceMappingURL=utils.js.map
